(() => {
  const i18n = window.MayLondonI18n;
  const { t } = i18n;
  if (window.MayLondonStorefront) return;
  window.MayLondonStorefront = true;
  const config = JSON.parse(document.getElementById('MayLondonConfig')?.textContent || '{}');
  const root = i18n.route('/').replace(/\/+$/, '') + '/';
  const money = i18n.money;
  const safeUrl = (value) => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin ? i18n.route(url.pathname + url.search + url.hash) : root; }
    catch (_) { return root; }
  };
  const saveLocal = (key, value) => { try { localStorage.setItem(key, value); } catch (_) { /* Storage can be unavailable in private browsing. */ } };
  const getLocal = (key) => { try { return localStorage.getItem(key); } catch (_) { return null; } };
  let cartBusy = false;
  let lastCart = null;
  let cartRenderSequence = 0;
  const rewardDismissedKey = 'mayLondonRewardDismissed';
  const recentlyViewedKey = 'mayLondonRecentlyViewed';
  const wishlistKey = 'mayLondonWishlist';

  const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const imageUrl = (value, width) => {
    try {
      const url = new URL(value, location.origin);
      if (!['https:', 'http:'].includes(url.protocol) || (url.origin !== location.origin && url.hostname !== 'cdn.shopify.com')) return '';
      if (url.pathname.includes('/cdn/shop/') || url.hostname === 'cdn.shopify.com') url.searchParams.set('width', String(width));
      return url.href;
    } catch (_) { return ''; }
  };
  const imageMarkup = (item, width = 92, lazy = true, hover = false) => {
    const src = imageUrl(item.image, width * 2);
    if (!src) return '<span class="cart-item__image-fallback">ML</span>';
    const srcset = [1, 2, 3].map(scale => `${escapeHtml(imageUrl(item.image, width * scale))} ${scale}x`).join(', ');
    const seen = new Set([src]);
    const photos = hover && Array.isArray(item.photos) ? item.photos.map(photo => ({ src: imageUrl(photo?.src, width * 2), detail: photo?.detail === true })).filter(photo => {
      if (!photo.src || seen.has(photo.src)) return false;
      seen.add(photo.src); return true;
    }).sort((a, b) => Number(b.detail) - Number(a.detail)) : [];
    const sequence = photos.length ? `<span class="product-card__hover" aria-hidden="true">${photos.map(photo => `<template data-hover-template><img src="${escapeHtml(photo.src)}" alt="" width="${width}" height="${Math.round(width * 4 / 3)}" loading="eager" fetchpriority="low"></template>`).join('')}</span>` : '';
    return `<span class="product-photo${hover ? ' product-card__media' : ''}"><img src="${escapeHtml(src)}" srcset="${srcset}" alt="${escapeHtml(item.title)}" width="${width}" height="${Math.round(width * 4 / 3)}" loading="${lazy ? 'lazy' : 'eager'}" decoding="async" draggable="false">${sequence}<span class="product-watermark" aria-hidden="true"></span></span>`;
  };

  const trackEvent = (name, detail = {}) => {
    window.MayLondonTrack?.(name, detail);
  };
  const trackCartView = () => {
    if (!lastCart || (!cartPageItems && !drawer?.classList.contains('is-open'))) return;
    const signature = lastCart.items.map(item => `${item.variantId}:${item.quantity}:${item.linePrice}`).join('|');
    trackEvent('view_cart', {key:`cart-view-${signature}`,value:lastCart.subtotal/100,items:lastCart.items.map(item=>({item_id:String(item.productId),item_variant:String(item.variantId),item_name:item.title,price:item.price/100,quantity:item.quantity}))});
  };

  const cartLineDetail = (item) => {
    const properties = item.properties && typeof item.properties === 'object'
      ? Object.entries(item.properties)
        .filter(([key, value]) => value && !String(key).startsWith('_'))
        .map(([key, value]) => `${key}: ${value}`)
      : [];
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
      ? item.variant_title
      : '';
    return [variantTitle, ...properties].filter(Boolean).join(' · ') || 'May-London';
  };

  const showButtonFeedback = (button, message = t('added')) => {
    if (!button || !button.matches('[data-quick-add]')) return;
    const original = button.dataset.originalText || button.textContent.trim();
    button.dataset.originalText = original;
    button.textContent = message;
    window.setTimeout(() => {
      if (button.dataset.originalText) button.textContent = button.dataset.originalText;
    }, 1400);
  };

  let drawer, wishlistDrawer, sizeGuideModal, drawerItems, cartPageItems, cartCountEls,
    cartTitleCountEls, subtotalEls, checkoutDrawer, checkoutPage, wishlistItems,
    wishlistCountEls, wishlistTitleCountEls;
  const refreshDom = () => {
    drawer = document.querySelector('[data-cart-drawer]');
    wishlistDrawer = document.querySelector('[data-wishlist-drawer]');
    sizeGuideModal = document.querySelector('[data-size-guide-modal]');
    drawerItems = document.querySelector('[data-cart-items]');
    cartPageItems = document.querySelector('[data-cart-page-items]');
    cartCountEls = document.querySelectorAll('[data-cart-count]');
    cartTitleCountEls = document.querySelectorAll('[data-cart-title-count]');
    subtotalEls = document.querySelectorAll('[data-cart-subtotal], [data-cart-page-subtotal]');
    checkoutDrawer = document.querySelector('[data-cart-checkout]');
    checkoutPage = document.querySelector('[data-cart-page-checkout]');
    wishlistItems = document.querySelector('[data-wishlist-items]');
    wishlistCountEls = document.querySelectorAll('[data-wishlist-count]');
    wishlistTitleCountEls = document.querySelectorAll('[data-wishlist-title-count]');
  };
  refreshDom();
  const showCartError = (message) => {
    document.querySelectorAll('[data-cart-error]').forEach((el) => { el.hidden = false; el.textContent = message; });
  };
  const clearCartError = () => document.querySelectorAll('[data-cart-error]').forEach((el) => { el.hidden = true; el.textContent = ''; });
  const unlockCartControls = () => document.querySelectorAll('[data-cart-qty], [data-cart-remove]').forEach((el) => { el.disabled = el.dataset.cartStockBlocked === 'true'; });
  const apiJSON = async (path, options = {}) => {
    const response = await fetch(i18n.route(path), { signal: AbortSignal.timeout(20000), ...options, headers: { Accept: 'application/json', ...options.headers } });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || t('cart_error'));
    return data;
  };

  const rewardTiers = () => {
    return [
      { quantity: 2, percent: 5 }, { quantity: 3, percent: 10 },
      { quantity: 4, percent: 15 }, { quantity: 5, percent: 20 }
    ];
  };

  const rewardState = (quantity = 0) => {
    const tiers = rewardTiers();
    const finalTier = tiers[tiers.length - 1];
    const current = [...tiers].reverse().find((tier) => quantity >= tier.quantity) || null;
    const next = tiers.find((tier) => quantity < tier.quantity) || null;
    const progress = Math.min(100, Math.max(0, (quantity / finalTier.quantity) * 100));
    const message = current ? t('bundle_qualified', { percent: i18n.percent(current.percent) }) : t('bundle_remaining', { count: i18n.number(Math.max(0, 2 - quantity)) });

    return {
      current,
      next,
      finalTier,
      progress,
      message,
      unlocked: Boolean(current)
    };
  };

  const setBodyLock = () => {
    const drawerOpen = drawer?.classList.contains('is-open');
    const wishlistOpen = wishlistDrawer?.classList.contains('is-open');
    const sizeGuideOpen = sizeGuideModal?.classList.contains('is-open');
    const menuOpen = document.querySelector('[data-mobile-menu][open]');
    const filtersOpen = document.querySelector('[data-collection-filter-dialog][open]');
    document.body.classList.toggle('is-locked', Boolean(drawerOpen || wishlistOpen || sizeGuideOpen || menuOpen || filtersOpen));
  };

  const setMobileMenu = (open) => {
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    if (open && !menu.open) menu.showModal();
    else if (!open && menu.open) menu.close();
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', String(open));
    setBodyLock();
  };

  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    drawer.inert = !open;
    setBodyLock();
    manageModalFocus(drawer, open);
    if (open) trackCartView();
  };

  const setSizeGuide = (open) => {
    if (!sizeGuideModal) return;
    sizeGuideModal.hidden = !open;
    sizeGuideModal.classList.toggle('is-open', open);
    sizeGuideModal.setAttribute('aria-hidden', open ? 'false' : 'true');
    setBodyLock();
    manageModalFocus(sizeGuideModal, open);
  };

  const readWishlist = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter(item => item && /^[-\p{L}\p{N}\p{M}\u2122\u00ae]+$/u.test(item.handle || '') && typeof item.title === 'string').slice(0, 24) : [];
    } catch (_error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    saveLocal(wishlistKey, JSON.stringify(items));
  };

  const renderWishlist = () => {
    const items = readWishlist();
    wishlistCountEls.forEach((el) => {
      el.textContent = i18n.number(items.length);
      el.hidden = items.length === 0;
    });
    wishlistTitleCountEls.forEach((el) => {
      el.textContent = items.length === 0 ? '' : t('pieces', {}, items.length);
      el.hidden = items.length === 0;
    });

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = items.some((item) => item.handle === button.dataset.wishlistHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', t(active ? 'unsave_product' : 'save_product', {title:button.dataset.wishlistTitle || ''}));
      const icon = button.querySelector('span[aria-hidden="true"]');
      const label = button.querySelector('[data-wishlist-label]');
      if (icon) icon.textContent = active ? '♥' : '♡';
      if (label) label.textContent = active ? t('saved') : t('save_wishlist');
    });

    if (!wishlistItems) return items;
    wishlistItems.innerHTML = items.length
      ? `<div class="wishlist-actions"><button class="button" type="button" data-wishlist-add-all>${escapeHtml(t('add_all_to_bag'))}</button><p class="wishlist-status" role="status" data-wishlist-status></p></div>` + items.map((item, index) => `
        <article class="wishlist-item">
          <a href="${escapeHtml(safeUrl(item.url))}">
            ${imageMarkup(item, 68)}
            <div>
              <h3>${escapeHtml(item.title)}</h3>
              ${item.currency === config.currency ? `<p>${money(item.price)}</p>` : ''}
            </div>
          </a>
          <button type="button" data-wishlist-remove data-wishlist-handle="${escapeHtml(item.handle)}" aria-label="${escapeHtml(t('remove'))}"><span aria-hidden="true">&times;</span></button>
          <div class="wishlist-item__actions" data-wishlist-product="${escapeHtml(item.handle)}" data-wishlist-index="${index}"><button class="button" type="button" data-wishlist-add="${escapeHtml(item.handle)}">${escapeHtml(t('add_to_bag'))}</button></div>
        </article>
      `).join('')
      : document.getElementById('WishlistEmptyTemplate')?.innerHTML || `<p>${escapeHtml(t('wishlist_empty'))}</p>`;
    if (wishlistDrawer?.classList.contains('is-open')) queueMicrotask(loadWishlistOptions);
    return items;
  };

  const setWishlistDrawer = (open) => {
    if (!wishlistDrawer) return;
    wishlistDrawer.classList.toggle('is-open', open);
    wishlistDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    wishlistDrawer.inert = !open;
    setBodyLock();
    manageModalFocus(wishlistDrawer, open);
    if (open) loadWishlistOptions();
  };

  const wishlistProducts = new Map();
  let wishlistRevision = 0;
  const wishlistMessage = message => {
    const status = wishlistDrawer?.querySelector('[data-wishlist-status]');
    if (status) status.textContent = message;
  };
  const getWishlistProduct = async handle => {
    if (!/^[-\p{L}\p{N}\p{M}\u2122\u00ae]+$/u.test(handle)) throw new Error(t('unavailable'));
    const product = await apiJSON(`products/${encodeURIComponent(handle)}.js`);
    if (!Array.isArray(product.variants)) throw new Error(t('unavailable'));
    wishlistProducts.set(handle, product);
    return product;
  };
  const loadWishlistOptions = async () => {
    const revision = ++wishlistRevision;
    for (const row of wishlistDrawer.querySelectorAll('[data-wishlist-product]')) {
      const handle = row.dataset.wishlistProduct;
      const button = row.querySelector('[data-wishlist-add]');
      button.disabled = true;
      try {
        const product = await getWishlistProduct(handle);
        if (revision !== wishlistRevision || !row.isConnected) return;
        const variants = product.variants.filter(variant => variant.available);
        row.querySelector('select')?.remove();
        if (product.variants.length > 1 && variants.length) {
          const select = document.createElement('select');
          select.dataset.wishlistVariant = handle;
          select.setAttribute('aria-label', t('choose_options'));
          select.add(new Option(t('choose_options'), ''));
          product.variants.forEach(variant => {
            const option = new Option(`${variant.public_title || variant.title} - ${money(variant.price)}${variant.available ? '' : ' (' + t('sold_out') + ')'}`, String(variant.id));
            option.disabled = !variant.available;
            select.add(option);
          });
          row.prepend(select);
        }
        button.disabled = variants.length === 0;
        button.textContent = t(variants.length ? 'add_to_bag' : 'sold_out');
      } catch (_) {
        button.disabled = false;
        button.textContent = t('retry');
        wishlistMessage(t('wishlist_load_error'));
      }
    }
  };
  const addWishlist = async (handles, trigger) => {
    if (cartBusy) return;
    cartBusy = true;
    trigger.setAttribute('aria-busy', 'true');
    trigger.disabled = true;
    wishlistMessage(t('loading'));
    let added = false;
    try {
      const lines = [];
      for (const handle of handles) {
        const row = [...wishlistDrawer.querySelectorAll('[data-wishlist-product]')].find(row => row.dataset.wishlistProduct === handle);
        const selectedId = row?.querySelector('select')?.value;
        const product = await getWishlistProduct(handle);
        if (!product.variants.some(variant => variant.available)) continue;
        const variant = product.variants.length === 1 ? product.variants[0] : product.variants.find(variant => String(variant.id) === selectedId);
        if (!variant) {
          wishlistMessage(t('choose_all_options'));
          row?.querySelector('select')?.focus();
          if (!row?.querySelector('select')) await loadWishlistOptions();
          return;
        }
        if (!variant.available) throw new Error(t('sold_out'));
        lines.push({ id: variant.id, quantity: 1 });
      }
      if (!lines.length) { wishlistMessage(t('sold_out')); return; }
      await apiJSON('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: lines }) });
      added = true;
      await renderCart();
      wishlistMessage(t('added'));
      setWishlistDrawer(false);
      setDrawer(true);
    } catch (error) {
      await renderCart().catch(() => {});
      wishlistMessage(added ? t('added_refresh') : i18n.message(error, 'cart_check_before_retry'));
    } finally {
      cartBusy = false;
      unlockCartControls();
      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
    }
  };

  const fetchShopifyCart = () => apiJSON('cart.js', { cache: 'no-store' });

  const fetchCartStock = async (items) => {
    try {
      const response = await fetch(i18n.route('cart?section_id=cart-inventory'), { cache: 'no-store', signal: AbortSignal.timeout(8000) });
      if (!response.ok) return null;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const snapshot = JSON.parse(html.querySelector('[data-cart-stock]')?.textContent || 'null');
      if (!Array.isArray(snapshot?.items) || snapshot.items.length !== items.length) return null;
      const stock = new Map(snapshot.items.map(item => [item.key, item]));
      // A different tab can change the cart between these two requests.
      if (stock.size !== items.length || items.some(item => {
        const entry = stock.get(item.key);
        return !entry || String(entry.variant) !== String(item.variant_id) || entry.cartQuantity !== item.quantity;
      })) return null;
      return stock;
    } catch (_) { return null; }
  };

  const cartLineLimit = (item, items, stock) => {
    const entry = stock?.get(item.key);
    if (!entry || typeof entry.available !== 'boolean' || typeof entry.managed !== 'boolean') return null;
    if (!entry.available) return 0;
    if (!entry.managed || entry.policy === 'continue') return Infinity;
    if (entry.policy !== 'deny' || !Number.isSafeInteger(entry.quantity)) return null;
    const otherQuantity = items.reduce((sum, other) => sum + (String(other.variant_id) === String(item.variant_id) && other.key !== item.key ? other.quantity : 0), 0);
    return Math.max(0, entry.quantity - otherQuantity);
  };

  const getCartModel = async () => {
    const shopifyCart = await fetchShopifyCart();

    if (shopifyCart && shopifyCart.item_count > 0) {
      const stock = await fetchCartStock(shopifyCart.items);
      return {
        mode: 'shopify',
        itemCount: shopifyCart.item_count,
        subtotal: shopifyCart.total_price,
        items: shopifyCart.items.map((item) => ({
          id: item.key,
          variantId: item.variant_id,
          productId: item.product_id,
          url: item.url,
          title: item.product_title,
          detail: cartLineDetail(item),
          image: item.image || '',
          price: item.final_price,
          linePrice: item.final_line_price,
          quantity: item.quantity,
          maxQuantity: cartLineLimit(item, shopifyCart.items, stock)
        }))
      };
    }

    return { mode: 'shopify', itemCount: 0, subtotal: 0, items: [] };
  };

  const cartLine = (item, mode, page = false) => {
    const nextDown = Math.max(0, Math.min(item.quantity - 1, item.maxQuantity ?? Infinity));
    const nextUp = item.quantity + 1;
    const increaseBlocked = item.maxQuantity === null || nextUp > item.maxQuantity;
    const stockNote = item.maxQuantity === null ? t('cart_stock_unavailable')
      : Number.isFinite(item.maxQuantity) && item.quantity >= item.maxQuantity ? t('cart_stock_limit', { count: item.maxQuantity }) : '';
    const image = imageMarkup(item, page ? 100 : 80, false);

    return `
      <article class="cart-item${page ? ' cart-item--page' : ''}">
        ${image}
        <div class="cart-item__details">
          <h3>${escapeHtml(item.title)}</h3>
          <p>${escapeHtml(item.detail)}</p>
          <span class="cart-item__unit">${escapeHtml(t('each', {price:money(item.price)}))}</span>
          <div class="quantity-stepper" aria-label="${escapeHtml(t('quantity_for', {title:item.title}))}">
            <button type="button" data-cart-qty data-cart-mode="${mode}" data-cart-id="${escapeHtml(item.id)}" data-cart-quantity="${nextDown}" ${cartBusy ? 'disabled' : ''} aria-label="${escapeHtml(t('decrease_quantity'))}">-</button>
            <span>${i18n.number(item.quantity)}</span>
            <button type="button" data-cart-qty data-cart-mode="${mode}" data-cart-id="${escapeHtml(item.id)}" data-cart-quantity="${nextUp}" data-cart-stock-blocked="${increaseBlocked}" ${cartBusy || increaseBlocked ? 'disabled' : ''} aria-label="${escapeHtml(t('increase_quantity'))}">+</button>
          </div>
          ${stockNote ? `<p class="cart-item__stock" role="status">${escapeHtml(stockNote)}</p>` : ''}
        </div>
        <div class="cart-item__price">
          <strong>${money(item.linePrice)}</strong>
          <button class="cart-remove" type="button" data-cart-remove data-cart-mode="${mode}" data-cart-id="${escapeHtml(item.id)}" ${cartBusy ? 'disabled' : ''}>${escapeHtml(t('remove'))}</button>
        </div>
      </article>
    `;
  };

  const recentMarkup = () => {
    const items = window.MayLondonCatalog?.cachedRecent() || [];
    return items.filter((item) => item?.handle).slice(0, 3).map((item) =>
      `<a class="compact-recommendation" href="${escapeHtml(safeUrl(item.url))}">${imageMarkup(item, 64)}<span>${escapeHtml(item.title)}</span></a>`).join('');
  };
  const emptyCartMarkup = () => {
    const recent = recentMarkup();
    return (document.getElementById('CartEmptyTemplate')?.innerHTML || `<p>${escapeHtml(t('cart_empty'))}</p>`)
      + (recent ? `<div class="empty-recent"><h3>${escapeHtml(t('recently_viewed'))}</h3>${recent}</div>` : '');
  };

  const updateProgress = (quantity) => {
    const state = rewardState(quantity);

    document.querySelectorAll('[data-cart-progress]').forEach((bar) => {
      bar.style.width = `${state.progress}%`;
    });

    const tiers = rewardTiers();
    document.querySelectorAll('[data-reward-stage]').forEach((stage, index) => {
      const tier = tiers[index % tiers.length];
      stage.textContent = `${i18n.number(tier.quantity)}${tier.quantity === 5 ? '+' : ''} · ${i18n.percent(tier.percent)}`;
      const isComplete = quantity >= tier.quantity;
      const isNext = !isComplete && state.next && tier.quantity === state.next.quantity;
      stage.classList.toggle('is-complete', isComplete);
      stage.classList.toggle('is-next', Boolean(isNext));
    });

    document.querySelectorAll('[data-cart-remaining], [data-gift-remaining]').forEach((el) => {
      el.textContent = state.message;
    });

    const popup = document.querySelector('[data-free-gift]');
    if (popup) {
      popup.style.setProperty('--gift-progress', `${Math.max(8, state.progress)}%`);
      popup.classList.toggle('is-unlocked', state.unlocked);
    }

    document.querySelectorAll('[data-discount-code-box]').forEach((box) => {
      box.hidden = !state.unlocked;
      const value = box.querySelector('[data-discount-code-value]');
      const meta = box.querySelector('[data-discount-code-meta]');
      if (value) value.textContent = state.current ? t('bundle_qualified', {percent:i18n.percent(state.current.percent)}) : '';
      if (meta) meta.textContent = state.current
        ? t('bundle_next_note')
        : '';
    });

    document.querySelectorAll('[data-account-reward-link]').forEach((link) => {
      link.classList.toggle('is-disabled', !state.unlocked);
      link.setAttribute('aria-disabled', String(!state.unlocked));
      link.textContent = state.unlocked ? t('view_account') : t('locked');
    });
  };

  const updateCheckoutState = (model) => {
    const notes = document.querySelectorAll('[data-cart-mode-note]');
    const isEmpty = model.itemCount === 0;
    notes.forEach((note) => {
      note.textContent = t('checkout_note');
    });

    if (checkoutDrawer) {
      checkoutDrawer.href = isEmpty ? i18n.route(config.recommendationsUrl) : root + 'checkout';
      checkoutDrawer.textContent = isEmpty ? t('start_shopping') : t('checkout');
    }

    if (checkoutPage) {
      checkoutPage.href = isEmpty ? i18n.route(config.recommendationsUrl) : root + 'checkout';
      checkoutPage.textContent = isEmpty ? t('start_shopping') : t('checkout');
      checkoutPage.classList.remove('is-disabled');
      checkoutPage.setAttribute('aria-disabled', 'false');
    }
  };

  const renderCart = async () => {
    const sequence = ++cartRenderSequence;
    const model = await getCartModel();
    if (sequence !== cartRenderSequence) return lastCart;
    lastCart = model;
    refreshDom();

    cartCountEls.forEach((el) => {
      el.textContent = i18n.number(model.itemCount);
      el.hidden = model.itemCount === 0;
    });

    cartTitleCountEls.forEach((el) => {
      el.textContent = model.itemCount === 0
        ? t('empty')
        : t('pieces', {}, model.itemCount);
    });

    subtotalEls.forEach((el) => {
      el.textContent = money(model.subtotal);
    });

    if (drawerItems) {
      drawerItems.innerHTML = model.items.length
        ? model.items.map((item) => cartLine(item, model.mode)).join('')
        : emptyCartMarkup();
    }

    if (cartPageItems) {
      cartPageItems.innerHTML = model.items.length
        ? model.items.map((item) => cartLine(item, model.mode, true)).join('')
        : emptyCartMarkup(true);
    }

    document.querySelectorAll('[data-cart-footer]').forEach((el) => { el.hidden = !model.itemCount; });
    updateProgress(model.itemCount);
    updateCheckoutState(model);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { items: model.items } }));
    trackCartView();
    return model;
  };

  const maybePromptGift = (model) => {
    if (!model || model.itemCount === 0) return;
    const popup = document.querySelector('[data-free-gift]');
    const state = rewardState(model.itemCount);
    const dismissKey = state.current ? `bundle-next-${state.current.percent}-${state.current.quantity}` : '';
    if (state.unlocked && popup && getLocal(rewardDismissedKey) !== dismissKey) {
      popup.classList.add('is-open');
    }
  };

  const updateShopifyQuantity = async (key, quantity) => {
    if (cartBusy) return;
    cartBusy = true;
    ++cartRenderSequence;
    clearCartError();
    document.querySelectorAll('[data-cart-qty], [data-cart-remove]').forEach((el) => { el.disabled = true; });
    try {
      if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error(t('cart_error'));
      const fresh = await getCartModel();
      const item = fresh.items.find(line => line.id === key);
      if (!item) throw new Error(t('cart_check_before_retry'));
      if (quantity > 0) {
        if (item.maxQuantity === null && quantity > item.quantity) throw new Error(t('cart_stock_unavailable'));
        if (item.maxQuantity !== null && quantity > item.maxQuantity) throw new Error(t('cart_stock_limit', { count: item.maxQuantity }));
      }
      await apiJSON('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const model = await renderCart();
      maybePromptGift(model);
    } catch (error) {
      await renderCart().catch(() => {});
      throw error;
    } finally {
      cartBusy = false;
      unlockCartControls();
    }
  };

  const focusOrigins = new WeakMap();
  const manageModalFocus = (modal, open) => {
    if (open) {
      focusOrigins.set(modal, document.activeElement);
      requestAnimationFrame(() => (modal.querySelector('[role="dialog"]') || modal).querySelector('button, a[href], input, [tabindex="0"]')?.focus());
    } else {
      const origin = focusOrigins.get(modal);
      if (origin?.isConnected) origin.focus();
      focusOrigins.delete(modal);
    }
  };

  document.addEventListener('click', async (event) => {
    try {
    const openCart = event.target.closest('[data-cart-open]');
    const closeCart = event.target.closest('[data-cart-close]');
    const openWishlist = event.target.closest('[data-wishlist-open]');
    const wishlistAdd = event.target.closest('[data-wishlist-add]');
    const wishlistAddAll = event.target.closest('[data-wishlist-add-all]');
    const closeWishlist = event.target.closest('[data-wishlist-close]');
    const wishlistToggle = event.target.closest('[data-wishlist-toggle]');
    const wishlistRemove = event.target.closest('[data-wishlist-remove]');
    const qty = event.target.closest('[data-cart-qty]');
    const remove = event.target.closest('[data-cart-remove]');
    const menuToggle = event.target.closest('[data-menu-toggle]');
    const faqToggle = event.target.closest('[data-faq-toggle]');
    const giftClose = event.target.closest('[data-gift-close]');
    const accountRewardLink = event.target.closest('[data-account-reward-link]');
    const sizeGuideOpen = event.target.closest('[data-size-guide-open]');
    const sizeGuideClose = event.target.closest('[data-size-guide-close]');
    const disabledCheckout = event.target.closest('[data-cart-page-checkout].is-disabled');

    if (wishlistAdd || wishlistAddAll) {
      event.preventDefault();
      await addWishlist(wishlistAdd ? [wishlistAdd.dataset.wishlistAdd] : readWishlist().map(item => item.handle), wishlistAdd || wishlistAddAll);
      return;
    }

    if (openCart) {
      event.preventDefault();
      setMobileMenu(false);
      const model = await renderCart();
      setDrawer(true);
      maybePromptGift(model);
    }

    if (closeCart) {
      event.preventDefault();
      setDrawer(false);
    }

    if (openWishlist) {
      event.preventDefault();
      setMobileMenu(false);
      renderWishlist();
      setWishlistDrawer(true);
    }

    if (closeWishlist) {
      event.preventDefault();
      setWishlistDrawer(false);
    }

    if (wishlistToggle) {
      event.preventDefault();
      const item = {
        handle: wishlistToggle.dataset.wishlistHandle,
        title: wishlistToggle.dataset.wishlistTitle,
        url: wishlistToggle.dataset.wishlistUrl,
        image: wishlistToggle.dataset.wishlistImage,
        price: Number(wishlistToggle.dataset.wishlistPrice || 0),
        currency: config.currency
      };
      const items = readWishlist();
      const exists = items.some((entry) => entry.handle === item.handle);
      const nextItems = exists
        ? items.filter((entry) => entry.handle !== item.handle)
        : [item, ...items.filter((entry) => entry.handle !== item.handle)].slice(0, 24);
      writeWishlist(nextItems);
      renderWishlist();
      trackEvent(exists ? 'wishlist_remove' : 'wishlist_add', { handle: item.handle, title: item.title });
    }

    if (wishlistRemove) {
      event.preventDefault();
      const items = readWishlist().filter((entry) => entry.handle !== wishlistRemove.dataset.wishlistHandle);
      writeWishlist(items);
      renderWishlist();
      trackEvent('wishlist_remove', { handle: wishlistRemove.dataset.wishlistHandle });
    }

    if (sizeGuideOpen) {
      event.preventDefault();
      sizeGuideModal = document.getElementById(sizeGuideOpen.dataset.sizeGuideOpen) || document.querySelector('[data-size-guide-modal]');
      setSizeGuide(true);
    }

    if (sizeGuideClose) {
      event.preventDefault();
      setSizeGuide(false);
    }

    if (qty) {
      event.preventDefault();
      const nextQuantity = Number(qty.dataset.cartQuantity);
      await updateShopifyQuantity(qty.dataset.cartId, nextQuantity);
    }

    if (remove) {
      event.preventDefault();
      await updateShopifyQuantity(remove.dataset.cartId, 0);
    }

    if (disabledCheckout) {
      event.preventDefault();
      disabledCheckout.blur();
    }

    if (menuToggle) {
      setMobileMenu(!document.querySelector('[data-mobile-menu]')?.open);
    }
    if (event.target.closest('[data-menu-close], [data-mobile-menu] a[href]')) setMobileMenu(false);
    if (event.target.matches('[data-mobile-menu]')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) setMobileMenu(false);
    }

    if (faqToggle) {
      const item = faqToggle.closest('.faq-item');
      const list = faqToggle.closest('.faq-list');
      const shouldOpen = !item?.classList.contains('is-open');

      list?.querySelectorAll('.faq-item.is-open').forEach((openItem) => {
        if (openItem === item) return;
        openItem.classList.remove('is-open');
        openItem.querySelector('[data-faq-toggle]')?.setAttribute('aria-expanded', 'false');
      });

      item?.classList.toggle('is-open', shouldOpen);
      faqToggle.setAttribute('aria-expanded', String(shouldOpen));
    }

    if (giftClose) {
      const model = await getCartModel();
      const state = rewardState(model.itemCount);
      const popup = document.querySelector('[data-free-gift]');
      popup?.classList.remove('is-open');
      const dismissKey = state.current ? `bundle-next-${state.current.percent}-${state.current.quantity}` : 'closed';
      saveLocal(rewardDismissedKey, dismissKey);
    }

    if (accountRewardLink && accountRewardLink.getAttribute('aria-disabled') === 'true') event.preventDefault();
    const checkout = event.target.closest('[data-cart-checkout], [data-cart-page-checkout]');
    if (checkout && cartBusy) event.preventDefault();
    if (checkout && !event.defaultPrevented && lastCart?.itemCount && lastCart.mode === 'shopify') {
      trackEvent('begin_checkout', { key: `checkout-${lastCart.items.map((item) => `${item.variantId}:${item.quantity}:${item.price}`).join(',')}`, value: lastCart.subtotal / 100, items: lastCart.items.map((item) => ({ item_id: String(item.productId), item_name: item.title, item_variant: String(item.variantId), price: item.price / 100, quantity: item.quantity })) });
    }
    } catch (error) { showCartError(i18n.message(error, 'cart_error')); }
  });

  document.addEventListener('change', (event) => {
    const fallbackOption = event.target.closest('[data-fallback-option]');
    if (!fallbackOption) return;
    const scope = fallbackOption.closest('.product-main__info') || document;
    const label = scope.querySelector(`[data-fallback-selected="${fallbackOption.dataset.fallbackOption}"]`);
    if (label) label.textContent = fallbackOption.value;
  });

  document.addEventListener('submit', async (event) => {
    const discountForm = event.target.closest('[data-discount-form]');
    const newsletterForm = event.target.closest('[data-newsletter-form], .newsletter-form');
    const productForm = event.target.closest('[data-product-form], .js-product-form');

    if (newsletterForm) {
      event.preventDefault();
      if (newsletterForm.dataset.busy === 'true') return;
      newsletterForm.dataset.busy = 'true';
      const message = newsletterForm.querySelector('[data-newsletter-message]');
      const button = newsletterForm.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      try {
        const endpoint = new URL(newsletterForm.action, location.origin);
        if (endpoint.origin !== location.origin || endpoint.username || endpoint.password) throw new Error(t('newsletter_error'));
        const response = await fetch(endpoint, { method: 'POST', credentials: 'same-origin', mode: 'same-origin', cache: 'no-store', referrerPolicy: 'no-referrer', signal: AbortSignal.timeout(20000), body: new FormData(newsletterForm), headers: { Accept: 'text/html' } });
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const returnedForm = newsletterForm.id ? html.getElementById(newsletterForm.id) : html;
        const success = returnedForm?.querySelector('[data-newsletter-success="true"]');
        if (!response.ok || !success) {
          const url = new URL(response.url);
          if (url.origin === location.origin && url.pathname.includes('challenge')) {
            location.assign(url.href);
            return;
          }
          throw new Error(html.querySelector('.newsletter-form [data-newsletter-message]')?.textContent.trim() || t('newsletter_unconfirmed'));
        }
        if (message) message.textContent = success.textContent.trim() || t('newsletter_success');
        newsletterForm.reset();
        try { localStorage.setItem('mayLondonNewsletterJoined', 'true'); } catch (_) {}
      } catch (error) {
        if (message) message.textContent = i18n.message(error, 'newsletter_error');
      } finally {
        newsletterForm.dataset.busy = 'false';
        if (button) button.disabled = false;
      }
      return;
    }

    if (discountForm) {
      event.preventDefault();
      const input = discountForm.querySelector('input[name="discount"]');
      const message = discountForm.querySelector('[data-discount-message]');
      const code = input?.value.trim();
      const model = await getCartModel().catch(() => null);

      if (!code) {
        if (message) message.textContent = t('enter_account_code');
        return;
      }

      if (!config.loggedIn) {
        if (message) {
          message.textContent = t('sign_in_code') + ' ';
          const link = document.createElement('a'); link.href = config.accountUrl || root + 'account/login'; link.textContent = t('sign_in'); message.append(link);
        }
        return;
      }
      if (model?.mode === 'shopify' && model.itemCount > 0) {
        trackEvent('discount_apply', { mode: 'shopify' });
        window.location.href = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(root + 'checkout')}`;
      } else if (message) {
        message.textContent = t('account_code_unavailable');
      }
      return;
    }

    if (!productForm) return;
    event.preventDefault();
    if (cartBusy || productForm.dataset.busy === 'true') return;
    const button = productForm.querySelector('[type="submit"]');
    if (button?.disabled) return;
    const variant = productForm.querySelector('[name="id"]');
    if (!variant?.value) return;
    cartBusy = true;
    productForm.dataset.busy = 'true';
    ++cartRenderSequence;
    button?.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    const errorEl = productForm.querySelector('[data-product-error]');
    if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; }
    let added = false;
    try {
      const batch = productForm.mayLondonItems?.();
      const result = await apiJSON('cart/add.js', batch ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: batch }) } : { method: 'POST', body: new FormData(productForm) });
      added = true;
      const addedItems = result.items || [result];
      trackEvent('add_to_cart', { mode: 'shopify', value: addedItems.reduce((sum, item) => sum + (item.final_price ?? item.price) * item.quantity / 100, 0), items: addedItems.map(item => ({ item_id: String(item.product_id), item_name: item.product_title, item_variant: String(item.variant_id), price: (item.final_price ?? item.price) / 100, quantity: item.quantity })) });
      const model = await renderCart();
      setDrawer(true);
      maybePromptGift(model);
      showButtonFeedback(button);
    } catch (error) {
      const message = added ? t('added_refresh') : i18n.message(error, 'cart_error');
      if (errorEl) { errorEl.hidden = false; errorEl.textContent = message; }
      else { showCartError(message); setDrawer(true); }
    } finally {
      cartBusy = false;
      productForm.dataset.busy = 'false';
      unlockCartControls();
      button?.removeAttribute('aria-busy');
      const selected = productForm.querySelector('[data-variant-select]');
      if (button) button.disabled = Boolean(selected?.disabled || selected?.selectedOptions[0]?.dataset.available === 'false');
      productForm.dispatchEvent(new Event('may-london:cart-settled'));
    }
  });

  document.addEventListener('keydown', (event) => {
    const openModal = [...document.querySelectorAll('[role="dialog"]')].find((el) => el.closest('.is-open'));
    if (event.key === 'Tab' && openModal) {
      const focusable = [...openModal.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), select, [tabindex="0"]')].filter((el) => el.getClientRects().length);
      if (focusable.length && event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable[focusable.length - 1].focus(); }
      else if (focusable.length && !event.shiftKey && document.activeElement === focusable[focusable.length - 1]) { event.preventDefault(); focusable[0].focus(); }
    }
    if (event.key === 'Escape') {
      document.querySelectorAll('.site-header details[open]').forEach((el) => { el.open = false; });
      setMobileMenu(false);
      setDrawer(false);
      setWishlistDrawer(false);
      setSizeGuide(false);
      document.querySelector('[data-free-gift]')?.classList.remove('is-open');
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (sizeGuideModal && event.target.contains(sizeGuideModal)) setSizeGuide(false);
    if (event.target.querySelector('[data-mobile-menu]')) setMobileMenu(false);
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches('[data-mobile-menu]')) {
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      setBodyLock();
    }
  }, true);
  const desktopMenuQuery = window.matchMedia('(min-width: 961px)');
  desktopMenuQuery.addEventListener?.('change', (event) => { if (event.matches) setMobileMenu(false); });

  let recentRevision = 0;
  const initRecentlyViewed = async () => {
    const revision = ++recentRevision;
    const section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    const grid = section.querySelector('[data-recently-viewed-grid]');
    const currentScript = section.querySelector('[data-recently-viewed-current]');
    const limit = Number(section.dataset.recentLimit || 4);

    const readItems = () => {
      try {
        const parsed = JSON.parse(localStorage.getItem(recentlyViewedKey) || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (_error) {
        return [];
      }
    };

    let current = null;
    if (currentScript?.textContent) {
      try {
        current = JSON.parse(currentScript.textContent);
      } catch (_error) {
        current = null;
      }
    }

    const existingItems = readItems();
    const displayItems = await window.MayLondonCatalog.recent(limit, current?.handle);
    if (revision !== recentRevision || !section.isConnected) return;

    if (grid && displayItems.length) {
      section.hidden = false;
      grid.innerHTML = displayItems.map((item) => `
        <article class="recently-card">
          <a href="${escapeHtml(safeUrl(item.url))}" aria-label="${escapeHtml(item.title)}">
            ${imageMarkup(item, 280, true, true)}
            <strong>${escapeHtml(item.title)}</strong>
            ${item.currency === config.currency ? `<span class="search-tile__price">${Number(item.compare) > Number(item.price) ? `<s>${money(item.compare)}</s>` : ''}<strong>${money(item.price)}</strong>${window.MayLondonCatalog.icons(item)}</span>` : window.MayLondonCatalog.icons(item)}
          </a>
        </article>
      `).join('');
    }

    if (current?.handle && current.hidden !== true) {
      const nextItems = [current, ...existingItems.filter((item) => item.handle !== current.handle)].slice(0, 8);
      saveLocal(recentlyViewedKey, JSON.stringify(nextItems));
      // view_item is owned by the product controller.
    }
  };

  document.addEventListener('shopify:section:load', () => {
    refreshDom();
    renderWishlist();
    initRecentlyViewed();
    renderCart().catch((error) => showCartError(i18n.message(error, 'cart_error')));
  });
  document.addEventListener('may-london:products-rendered', renderWishlist);
  document.addEventListener('may-london:consent-ready', trackCartView);
  document.addEventListener('may-london:cart-refresh', () => {
    renderCart().catch((error) => showCartError(i18n.message(error, 'cart_error')));
  });
  window.addEventListener('focus', () => {
    if (!cartBusy && (cartPageItems || drawer?.classList.contains('is-open'))) renderCart().catch(() => {});
  });
  document.addEventListener('toggle', (event) => {
    if (!(event.target instanceof HTMLDetailsElement) || !event.target.open) return;
    const group = event.target.closest('[data-single-accordion], .product-accordions');
    group?.querySelectorAll('details[open]').forEach((el) => { if (el !== event.target) el.open = false; });
  }, true);
  renderWishlist();
  initRecentlyViewed();
  renderCart().catch((error) => showCartError(i18n.message(error, 'cart_error')));
})();
